export default __webpack_public_path__ + "static/media/ic_discord.0dfc81d5.svg";